// import { Button } from '@mui/material';
// import * as _ from 'lodash';
// import React, { useCallback } from 'react';
// import { BiChevronLeft } from 'react-icons/bi';
// import { HiOutlineMenuAlt1 } from 'react-icons/hi';
// import { Link } from 'react-router-dom';
// import { MdLogout } from 'react-icons/md';

// const AdminHeader = (props) => {
//   const { title, backTo, showButton, buttonText, onClickButton } = props;

//   const handleClick = useCallback(() => {
//     window.location.href = '/login';
//   }, []);

//   return (
//     <div className='header-container__main'>
//       <div className='header-container__inner'>
//         <div className='header-left-content__block'>
//           <div className='header-left-icon'>
//             {backTo && !_.isEmpty(backTo) ? (
//               <Link to={backTo} className='back-to-link'>
//                 <BiChevronLeft />
//               </Link>
//             ) : (
//               <HiOutlineMenuAlt1 />
//             )}
//           </div>
//           <div className='header-page--title'>
//             <span>{title}</span>
//           </div>

//           {/* {showButton && (
//             <div className='header-left--btn'>
//               <Button className='header--btn' onClick={onClickButton}>
//                 {buttonText}
//               </Button>
//             </div>
//           )} */}
//         </div>
//       </div>
//       <div className='header-left--btn'>
//         <MdLogout
//           size={22}
//           style={{
//            cursor:'pointer',
//            pointerEvents :'unset'
//           }}
//           onClick={() => {
//             localStorage.clear();
//             window.location.href = '/login';
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default AdminHeader;

import {
  Avatar,
  Typography,
  Button,
  AppBar,
  Box,
  IconButton,
  Toolbar,
} from '@mui/material';
import * as _ from 'lodash';
import React, { useCallback, useContext } from 'react';
import { BiChevronLeft } from 'react-icons/bi';
import { HiOutlineMenuAlt1 } from 'react-icons/hi';
import { MdLogout } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/style.css';
import PRO360 from '../assets/images/pro360.png';
import { HiOutlineBars3 } from 'react-icons/hi2';
import { SidebarContext } from './SidebarContext';

const AdminHeader = (props) => {
  const { title, backTo, showButton, buttonText, onClickButton } = props;
  const navigate = useNavigate();
  const roles = JSON.parse(localStorage?.getItem('roles') || '[]');
  const { isMobileLayout, toggleMobileSidebar } = useContext(SidebarContext);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    window.location.href = '/login';
  }, []);

  return (
    <div
      className='header-container'
      style={{
        position: isMobileLayout ? 'sticky' : undefined,
        top: isMobileLayout ? 0 : undefined,
        zIndex: isMobileLayout ? 1100 : undefined,
        backgroundColor: '#ffffff',
      }}
    >
      {/* Left Section with Back/Menu Icon and Title */}
      <div className='header-left'>
        <div className='header-icon'>
          {backTo && !_.isEmpty(backTo) ? (
            <Link to={backTo} className='back-to-link'>
              <BiChevronLeft size={24} />
            </Link>
          ) : (
            <HiOutlineMenuAlt1
              size={24}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (isMobileLayout) toggleMobileSidebar?.();
              }}
            />
          )}
        </div>
        <Typography variant='h6' className='header-title'>
          {title}
        </Typography>

        {/* Optional Button */}
        {showButton && (
          <Button
            variant='contained'
            color='primary'
            onClick={onClickButton}
            style={{ marginLeft: '20px' }}
          >
            {buttonText}
          </Button>
        )}
      </div>

      {/* Right Section with Profile and Logout */}
      <div className='header-right'>
        <div className='profile-info'>
          <Typography variant='body1' className='profile-name'>
            {localStorage?.getItem('user_name')}
          </Typography>
          <Typography variant='body2' className='profile-role'>
            {roles?.[0]}
          </Typography>
        </div>
        <Avatar
          alt={_.first(localStorage?.getItem('user_name'))}
          src='/path-to-avatar.jpg'
          onClick={() => navigate('/change-password')}
          sx={{ cursor: 'pointer' }}
        />
        <MdLogout size={24} className='logout-icon' onClick={handleLogout} />
      </div>
    </div>
  );
};

export default AdminHeader;

export const UserHeader = () => {
  const navigate = useNavigate();
  return (
    <AppBar position='static' sx={{ bgcolor: '#2F3542' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton edge='start' color='inherit' aria-label='menu'>
            <HiOutlineBars3 />
          </IconButton>
          <img src={PRO360} style={{ width: 150, height: 60 }} />
        </Box>
        <Box>
          <MdLogout
            size={22}
            onClick={() => {
              localStorage.clear();
              navigate('/login');
            }}
            cursor={'pointer'}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
